import { updateProgramDay } from '../lib/grit-data.js';
import { toast } from './toast.js';

const WD = [['1', 'Monday'], ['2', 'Tuesday'], ['3', 'Wednesday'], ['4', 'Thursday'], ['5', 'Friday'], ['6', 'Saturday'], ['7', 'Sunday']];
const KIND = { lift: 'Lift', run: 'Run', hiit: 'HIIT', rest: 'Rest' };

let overlay = null;

// days = array of program_days ({id, name, kind, weekday}); onDone called after edits.
export function openScheduleEditor(days, onDone) {
  close();
  overlay = document.createElement('div');
  overlay.className = 'fixed inset-0 z-[120] flex items-end justify-center bg-black/30';
  const sorted = [...days].sort((a, b) => a.sort - b.sort);
  overlay.innerHTML = `
    <div class="grit-sheet overflow-auto">
      <div class="grit-sheet-handle"></div>
      <div class="text-[18px] font-bold text-ink">Edit your schedule</div>
      <div class="text-[13px] text-inksoft mb-3">Pick which day of the week each workout lands on.</div>
      <div class="space-y-2">
        ${sorted.map((d) => `
          <div class="flex items-center gap-3 bg-pagebg rounded-2xl p-3">
            <div class="flex-1 min-w-0">
              <div class="font-bold text-[15px] text-ink truncate">${d.name}</div>
              <div class="text-[12px] text-inksoft">${KIND[d.kind] || d.kind}</div>
            </div>
            <select data-day="${d.id}" class="grit-input w-auto py-2 pr-8 font-bold text-[15px]">
              ${WD.map(([v, lbl]) => `<option value="${v}" ${Number(v) === d.weekday ? 'selected' : ''}>${lbl}</option>`).join('')}
            </select>
          </div>`).join('')}
      </div>
      <button data-done class="grit-btn mt-4">Done</button>
    </div>`;

  overlay.addEventListener('click', (e) => { if (e.target === overlay) finish(); });
  overlay.querySelectorAll('select[data-day]').forEach((sel) => {
    sel.onchange = async () => { await updateProgramDay(sel.dataset.day, { weekday: Number(sel.value) }); toast('Schedule updated'); };
  });
  overlay.querySelector('[data-done]').onclick = finish;
  document.body.appendChild(overlay);

  function finish() { close(); onDone?.(); }
}

function close() { if (overlay) { overlay.remove(); overlay = null; } }
